import React, { useState, useEffect } from "react";
import { useCollection } from "../../../hooks/useCollection";
import { useFirestore } from "../../../hooks/useFirestore";
import "./TabellaPaghe.css";

const tipiStipendio = [
  { value: "Fisso", label: "Fisso" },
  { value: "Fisso+Straordinari", label: "Fisso + Straordinari" },
  { value: "Fisso+Sabato", label: "Fisso + Sabato" },
  { value: "Contratto", label: "Contratto" },
];

export default function TabellaPaghe() {
  const { documents: users } = useCollection("users");
  const { updateDocument } = useFirestore("users");
  const [tableData, setTableData] = useState([]);
  const [selectedBonusUser, setSelectedBonusUser] = useState(null);
  const [isBonusModalOpen, setIsBonusModalOpen] = useState(false);
  const [tempBonus, setTempBonus] = useState([]);

  // Inizializza i dati della tabella quando arrivano gli utenti
  useEffect(() => {
    if (users) {
      const data = users.map((user) => {
        const anagrafica = user.anagrafica || {};
        return {
          id: user.id,
          nome: anagrafica.nome || "",
          cognome: anagrafica.cognome || "",
          displayName: user.displayName || "Utente",
          mansione: anagrafica.mansione || "",
          tipoStipendio: anagrafica.tipoStipendio || "",
          importoFisso: anagrafica.importoFisso || "",
          oreViaggio: anagrafica.oreViaggio || "",
          oreStraordinarie: anagrafica.oreStraordinarie || "",
          pasto: anagrafica.pasto || "",
          bonus: anagrafica.bonus || [],
          originalData: anagrafica, // Per verificare se ci sono cambiamenti
        };
      });
      // Ordina per cognome e nome
      data.sort((a, b) => {
        const nameA = `${a.cognome} ${a.nome}`.toLowerCase();
        const nameB = `${b.cognome} ${b.nome}`.toLowerCase();
        return nameA.localeCompare(nameB);
      });
      setTableData(data);
    }
  }, [users]);

  const handleInputChange = (id, field, value) => {
    setTableData((prevData) =>
      prevData.map((row) => (row.id === id ? { ...row, [field]: value } : row)),
    );
  };

  const handleSaveRow = async (row) => {
    try {
      // Prepara l'oggetto di aggiornamento mantenendo gli altri dati dell'anagrafica
      const updatedAnagrafica = {
        ...row.originalData,
        mansione: row.mansione,
        tipoStipendio: row.tipoStipendio,
        importoFisso: row.importoFisso,
        oreViaggio: row.oreViaggio,
        oreStraordinarie: row.oreStraordinarie,
        pasto: row.pasto,
        bonus: row.bonus,
      };

      await updateDocument(row.id, {
        anagrafica: updatedAnagrafica,
      });

      alert(`Dati aggiornati per ${row.nome} ${row.cognome}`);
    } catch (error) {
      console.error("Errore durante il salvataggio:", error);
      alert("Errore durante il salvataggio");
    }
  };

  // Gestione Bonus Modal
  const openBonusModal = (userRow) => {
    setSelectedBonusUser(userRow);
    setTempBonus([...(userRow.bonus || [])]);
    setIsBonusModalOpen(true);
  };

  const closeBonusModal = () => {
    setIsBonusModalOpen(false);
    setSelectedBonusUser(null);
    setTempBonus([]);
  };

  const handleAddBonus = () => {
    setTempBonus([
      ...tempBonus,
      {
        id: Date.now(),
        nome: "",
        descrizione: "",
        importo: "",
        scadenza: "",
      },
    ]);
  };

  const handleBonusChange = (id, field, value) => {
    setTempBonus(
      tempBonus.map((b) => (b.id === id ? { ...b, [field]: value } : b)),
    );
  };

  const handleRemoveBonus = (id) => {
    setTempBonus(tempBonus.filter((b) => b.id !== id));
  };

  const saveBonus = () => {
    if (selectedBonusUser) {
      handleInputChange(selectedBonusUser.id, "bonus", tempBonus);
      closeBonusModal();
    }
  };

  if (!users) {
    return <div className="loading">Caricamento...</div>;
  }

  return (
    <div className="tabella-paghe-container">
      <h1 className="tabella-paghe-title">Tabella Paghe e Dati Contrattuali</h1>

      <div className="tabella-paghe-table-container">
        <table className="tabella-paghe-table">
          <thead>
            <tr>
              <th>Dipendente</th>
              <th>Tipo Stipendio</th>
              <th style={{ width: "100px" }}>Fisso (€)</th>
              <th style={{ width: "80px" }}>Viaggio (€/h)</th>
              <th style={{ width: "80px" }}>Straord. (€/h)</th>
              <th style={{ width: "80px" }}>Pasto (€)</th>
              <th>Bonus</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row) => (
              <tr key={row.id}>
                <td>
                  <strong>
                    {row.cognome} {row.nome}
                  </strong>
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {row.displayName}
                  </div>
                </td>
                <td className="input-cell">
                  <select
                    value={row.tipoStipendio}
                    onChange={(e) =>
                      handleInputChange(row.id, "tipoStipendio", e.target.value)
                    }
                  >
                    <option value="">Seleziona...</option>
                    {tipiStipendio.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </select>
                </td>
                <td className="input-cell">
                  <input
                    type="number"
                    value={row.importoFisso}
                    onChange={(e) =>
                      handleInputChange(row.id, "importoFisso", e.target.value)
                    }
                    placeholder="0.00"
                  />
                </td>
                <td className="input-cell">
                  <input
                    type="number"
                    value={row.oreViaggio}
                    onChange={(e) =>
                      handleInputChange(row.id, "oreViaggio", e.target.value)
                    }
                    placeholder="0.00"
                  />
                </td>
                <td className="input-cell">
                  <input
                    type="number"
                    value={row.oreStraordinarie}
                    onChange={(e) =>
                      handleInputChange(
                        row.id,
                        "oreStraordinarie",
                        e.target.value,
                      )
                    }
                    placeholder="0.00"
                  />
                </td>
                <td className="input-cell">
                  <input
                    type="number"
                    value={row.pasto}
                    onChange={(e) =>
                      handleInputChange(row.id, "pasto", e.target.value)
                    }
                    placeholder="0.00"
                  />
                </td>
                <td>
                  <button
                    className="bonus-btn"
                    onClick={() => openBonusModal(row)}
                  >
                    {row.bonus && row.bonus.length > 0
                      ? `${row.bonus.length} Attivi`
                      : "Gestisci"}
                  </button>
                </td>
                <td>
                  <button
                    className="save-btn"
                    onClick={() => handleSaveRow(row)}
                  >
                    Salva
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isBonusModalOpen && selectedBonusUser && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">
                Bonus - {selectedBonusUser.nome} {selectedBonusUser.cognome}
              </h3>
              <button className="close-btn" onClick={closeBonusModal}>
                &times;
              </button>
            </div>

            <div className="modal-body">
              <button className="add-bonus-btn" onClick={handleAddBonus}>
                + Aggiungi Bonus
              </button>

              <div className="bonus-list">
                {tempBonus.map((bonus) => (
                  <div key={bonus.id} className="bonus-item">
                    <div className="bonus-grid-row">
                      <div className="form-group">
                        <label>Nome Bonus</label>
                        <input
                          type="text"
                          value={bonus.nome}
                          onChange={(e) =>
                            handleBonusChange(bonus.id, "nome", e.target.value)
                          }
                          placeholder="Es. Produzione"
                        />
                      </div>
                      <div className="form-group">
                        <label>Importo (€)</label>
                        <input
                          type="number"
                          value={bonus.importo}
                          onChange={(e) =>
                            handleBonusChange(
                              bonus.id,
                              "importo",
                              e.target.value,
                            )
                          }
                          placeholder="0.00"
                        />
                      </div>
                      <div className="form-group">
                        <label>Scadenza</label>
                        <input
                          type="date"
                          value={bonus.scadenza}
                          onChange={(e) =>
                            handleBonusChange(
                              bonus.id,
                              "scadenza",
                              e.target.value,
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Descrizione</label>
                      <textarea
                        value={bonus.descrizione}
                        onChange={(e) =>
                          handleBonusChange(
                            bonus.id,
                            "descrizione",
                            e.target.value,
                          )
                        }
                        placeholder="Dettagli aggiuntivi..."
                        rows="2"
                      />
                    </div>
                    <button
                      className="delete-btn-full"
                      onClick={() => handleRemoveBonus(bonus.id)}
                    >
                      Elimina Bonus
                    </button>
                  </div>
                ))}
                {tempBonus.length === 0 && (
                  <p className="no-bonus-msg">
                    Nessun bonus assegnato a questo dipendente.
                  </p>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn-secondary" onClick={closeBonusModal}>
                Annulla
              </button>
              <button className="btn-primary" onClick={saveBonus}>
                Salva Modifiche
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
